export const parseCsv = (text: string): string[][] => {
  if (!text?.trim()) {
    return [];
  }

  const normalizedText = text.replace(/^\uFEFF/, '');

  const rows: string[][] = [];
  let currentRow: string[] = [];
  let currentField = '';
  let inQuotes = false;
  let i = 0;

  while (i < normalizedText.length) {
    const char = normalizedText[i];

    if (inQuotes) {
      if (char === '"' && normalizedText[i + 1] === '"') {
        currentField += '"';
        i += 2;
        continue;
      }

      if (char === '"') {
        inQuotes = false;
        i++;
        continue;
      }

      currentField += char;
      i++;
      continue;
    }

    if (char === '"') {
      inQuotes = true;
      i++;
      continue;
    }

    if (char === ',') {
      currentRow.push(currentField);
      currentField = '';
      i++;
      continue;
    }

    if (char === '\r' || char === '\n') {
      currentRow.push(currentField);
      rows.push(currentRow);
      currentRow = [];
      currentField = '';
      i += char === '\r' && normalizedText[i + 1] === '\n' ? 2 : 1;
      continue;
    }

    currentField += char;
    i++;
  }

  if (currentField || currentRow.length > 0) {
    currentRow.push(currentField);
    rows.push(currentRow);
  }

  return rows;
};
